module.exports = __webpack_public_path__ + "static/assets/241be35c3ebd7ee2e5c2ea85f4581ecf.svg";